<form [formGroup]="parent" class="logintab" (ngSubmit)="loginClick()">
    <mat-expansion-panel class="mat-elevation-z0" [hideToggle]="true" [expanded]="foersteGangAktiveret">
        <div formGroupName="forbrugerNrGroup">
            <div>Indtast dit eksisterende login</div>
            @if (showHelpLink) {
            <div>
                <a href="javascript:void(0);" (click)="loginHjaelpClick()">{{ helpLinkText || "Hvor finder jeg mine loginoplysninger?" }}</a>
            </div>
            }
            <div>
                <mat-form-field fxLayout="column">
                    <mat-label>Forbrugernummer</mat-label>
                    <input matInput formControlName="forbrugerNr" type="number" id="forbrugernr" required />
                </mat-form-field>
            </div>
            <div>
                <mat-form-field fxLayout="column">
                    <mat-label>Kode (4 cifre)</mat-label>
                    <input matInput formControlName="kode" type="password" id="kode" required />
                </mat-form-field>
            </div>
        </div>
    </mat-expansion-panel>

    <div formGroupName="emailGroup" class="login-group-wrapper">
        @if (foersteGangAktiveret) {
        <div>Indtast din e-mail og ønskede adgangskode</div>
        }
        <div>
            <mat-form-field fxLayout="column">
                <mat-label>{{ emailPlaceholder || (technicianLogin ? "Email eller ID" : "Forbrugernummer eller E-mail") }}</mat-label>
                <input matInput #emailInput formControlName="email" id="email" required />
            </mat-form-field>
        </div>
        <div [hidden]="glemtKodeordAktiveret">
            <mat-form-field fxLayout="column">
                <mat-label>{{ passwordPlaceholder || (technicianLogin ? "Adgangskode" : "Adgangskode eller 4-cifret kode") }}</mat-label>
                <input matInput formControlName="adgangskode" type="password" id="adgangskode" required />
            </mat-form-field>
        </div>
    </div>
    <div [hidden]="glemtKodeordAktiveret">
        <mat-checkbox formControlName="huskMig" id="huskmig">Husk mig</mat-checkbox>
    </div>
    @if (infoBesked) {
    <div>{{ infoBesked }}</div>
    } @if (fejlBesked) {
    <div class="fejlBesked">{{ fejlBesked }}</div>
    } @if (!foersteGangAktiveret && !glemtKodeordAktiveret) {
    <div>
        <div class="log-ind-flex" fxLayoutAlign="end start">
            <button mat-flat-button color="primary" type="submit" id="login" [disabled]="loginDisabled" [ngClass]="technicianLogin ? 'backgroundcolor1' : null">
                Log ind
            </button>
            <ng-container *ngTemplateOutlet="biometricTemplate"></ng-container>
        </div>
        <div class="linkMargin">
            @if (showHelpLink) {
            <a href="javascript:void(0);" (click)="loginHjaelpClick()">{{ helpLinkText || "Hvor finder jeg mine loginoplysninger?" }}</a>
            } @if (!technicianLogin) {
            <a href="javascript:void(0);" (click)="onGlemtKodeordClick()">{{ forgotPasswordText || "Har du glemt din adgangskode?" }}</a>
            } @if (showFirstTimeLink) {
            <a href="javascript:void(0);" (click)="firstTimeClick()">{{ firstTimeText || "Er det første gang du logger ind med e-mail?" }}</a>
            }
        </div>
        <!--div>
      <a href="javascript:void(0);" (click)="firstTimeClick()">Ønsker du at samle flere logins?</a>
    </div-->
    </div>
    } @else { @if (!glemtKodeordAktiveret) {
    <div>
        <div fxLayoutAlign="end start">
            <button mat-button color="primary" (click)="firstTimeClick()">Fortryd</button>
            <button mat-flat-button color="primary" type="submit" id="opretLogin">Opret login</button>
        </div>
    </div>
    } @else {
    <div fxLayoutAlign="end start" class="glemtpwd">
        @if (!infoBesked) {
        <div>
            <button mat-button type="button" color="primary" (click)="onGlemtKodeordClick()">Fortryd</button>
            <button mat-flat-button color="primary" type="submit" id="sendEmail">Send mig en e-mail</button>
        </div>
        } @if (infoBesked) {
        <div>
            <button mat-flat-button color="primary" (click)="onGlemtKodeordClick()">Tilbage til login</button>
        </div>
        }
    </div>
    } }
</form>
